import { useFormatter } from '@api/useFormatter'
import { addCommasToNumber } from '@gravitate-js/excalibrr'
import { Col, Row, Select } from 'antd'
import React from 'react'

import { useWizardMaster } from '../../../../Contexts/WizardMasterContext'

const { Option } = Select

export function BackhaulProducts({ order }) {
  const { isEditingBackhaul } = useWizardMaster()
  return (
    <>
      {order.product_ratios.map((p, i) => {
        if (isEditingBackhaul) {
          return <BackhaulProductEdit product={p} key={i} />
        }
        return <BackhaulProductDisplay product={p} key={i} />
      })}
    </>
  )
}
function BackhaulProductDisplay({ product }) {
  const { formatVolume } = useFormatter()
  const formattedUnit = formatVolume(null, true)
  return (
    <Row className='p-4' style={{ borderBottom: 'solid 1px var(--gray-200)' }}>
      <Col span={8} className='vertical-flex-center'>
        <h3 className='backhaul-header mb-0'>{product.name}</h3>
        <div className='detail-data-label'>Total Volume</div>
      </Col>
      <Col span={16}>
        <div
          className='flex-div h-100 mt-1'
          style={{
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
          }}
        >
          <h1 className='mb-0 backhaul-product'>{product.volume && addCommasToNumber(product.volume)}</h1>
          <h3 className='pl-3 mb-3'>{formattedUnit}</h3>
        </div>
      </Col>
    </Row>
  )
}
function BackhaulProductEdit({ product, productOptions }) {
  const { formatVolume } = useFormatter()
  const formattedUnit = formatVolume(null, false)
  return (
    <Row gutter={10} className='p-4' style={{ borderBottom: 'solid 1px var(--gray-200)' }}>
      <Col span={12} className='vertical-flex-center'>
        <ProductSelect products={productOptions} defaultProduct={product.name} />
        <div className='detail-data-label'>Order Product</div>
      </Col>
      <Col span={12}>
        <div
          className='flex-div h-100'
          style={{
            flexDirection: 'column',
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
          }}
        >
          <h1 style={{ marginBottom: 0 }}>{product.volume && addCommasToNumber(product.volume)}</h1>
          <div style={{ paddingTop: '0.25em' }} className='detail-data-label'>
            Total {formattedUnit}
          </div>
        </div>
      </Col>
    </Row>
  )
}
function ProductSelect({ defaultProduct }) {
  const { updateBackhaulField, backhaulMeta } = useWizardMaster()
  const onChangeProduct = (value) => {
    updateBackhaulField('product', value)
  }
  return (
    <Select
      onChange={onChangeProduct}
      defaultValue={backhaulMeta && backhaulMeta.products.find((o) => o === defaultProduct)}
      optionFilterProp='children'
      showSearch
    >
      {backhaulMeta &&
        backhaulMeta.products.map((cp, i) => (
          <Option key={i} value={cp}>
            {cp}
          </Option>
        ))}
    </Select>
  )
}
